import { render } from "./_item.vue?vue&type=template&id=0afd8dfe"
import script from "./_item.vue?vue&type=script&lang=js"
export * from "./_item.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/reaction/_item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0afd8dfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0afd8dfe', __exports__)) {
    console.log('reload')
    api.reload('0afd8dfe', __exports__)
  }
  
  module.hot.accept("./_item.vue?vue&type=template&id=0afd8dfe", () => {
    console.log('re-render')
    api.rerender('0afd8dfe', render)
  })

}


export default __exports__